import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
// import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import StoreConfig from "./Store/ConfigStore";
import SignupJourney from "./Pages/Desktop/Broker/SignupJourney/SignupJourney";
import EnrollmentDrive from "./Pages/Desktop/EnrollmentDrive/EnrollmentDrive";

import HomeEmployees from "./Pages/Desktop/Employeev2/HomeEmployees/HomeEmployees";
import { BrowserRouter, Route, Routes } from "react-router-dom";
const ProviderComponent = () => {
  const store = StoreConfig();
  return (
    <Provider store={store}>
      <App />
    </Provider>
  );
};
ReactDOM.render(
  <React.StrictMode>
    <ProviderComponent />
  </React.StrictMode>,
  document.getElementById("root")
);
